import { useTranslation } from "react-i18next";
import { Button } from "~/components/button";
import { BetaBadge } from "~/components/beta-badge";
import { Text } from "~/components/text";

interface PageHeaderProps {
  onUploadClick?: () => void;
}

export const PageHeader = ({ onUploadClick }: PageHeaderProps) => {
  const { t } = useTranslation(["uploadManuscript"]);

  return (
    <div className="flex justify-between items-center">
      <Text as="h2" variant="heading" className="flex items-center">
        {t("uploadManuscript:title")}
        <BetaBadge />
      </Text>
      {onUploadClick && (
        <Button
          variant="ghost"
          icon="upload"
          analyticsId="button_upload_new_manuscript"
          label={t("uploadManuscript:button.uploadNew")}
          onClick={onUploadClick}
        />
      )}
    </div>
  );
};
